export default __webpack_public_path__ + "static/media/icon-384x384.1ff5fb1d.png";